// PC/SP image swap. <img class="js-image-switch" src="..._pc.jpg"> swaps to "..._sp.jpg" under 768px.
// Prefer <picture> in markup when possible — this is the legacy path.
export function initImageSwitch({ breakpoint = 768 } = {}) {
  const els = document.querySelectorAll('.js-image-switch');
  if (!els.length) return;
  const swap = () => {
    const isPc = window.innerWidth >= breakpoint;
    els.forEach((img) => {
      const src = img.getAttribute('src') || '';
      if (isPc && src.includes('_sp.')) img.setAttribute('src', src.replace('_sp.', '_pc.'));
      if (!isPc && src.includes('_pc.')) img.setAttribute('src', src.replace('_pc.', '_sp.'));
    });
  };
  swap();
  let t;
  window.addEventListener('resize', () => { clearTimeout(t); t = setTimeout(swap, 200); });
}
